// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.full-width {
  width: 100%;
}
.full-height {
  height: 100%;
}
.flex-h {
  display: flex;
  flex-direction: row;
}
.flex-v {
  display: flex;
  flex-direction: column;
}
.flex-grow {
  flex-grow: 1;
}
.nowrap {
  white-space: nowrap;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
h1 {
  font-size: 36px;
}
h3,
h1 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  margin-top: 20px;
  margin-bottom: 10px;
}
button,
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.row {
  margin-right: -15px;
  margin-left: -15px;
}
.pull-left {
  float: left !important;
}
.pull-right {
  float: right !important;
}
.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}
.fade.in {
  opacity: 1;
}
a {
  color: #8784ee;
  text-decoration: none;
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  opacity: 0;
  line-break: auto;
}
.tooltip.in {
  opacity: 0.9;
}
.tooltip.top {
  margin-top: -3px;
  padding: 5px 0;
}
.tooltip.right {
  margin-left: 3px;
  padding: 0 5px;
}
.tooltip.bottom {
  margin-top: 3px;
  padding: 5px 0;
}
.tooltip.left {
  margin-left: -3px;
  padding: 0 5px;
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.right .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #000;
}
.tooltip.left .tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #000;
}
.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 4px;
}
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.tooltip.in {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/common/global.styl","webpack://./../../ui/src/components/tooltip/Tooltip.styl"],"names":[],"mappings":"AAAA;EACE,8BAAoB;EACpB,2BAAiB;EACjB,sBAAY;ACCd;ADCA;EACE,WAAO;ACCT;ADCA;EACE,YAAQ;ACCV;ADCA;EACE,aAAS;EACT,mBAAgB;ACClB;ADCA;EACE,aAAS;EACT,sBAAgB;ACClB;ADCA;EACE,YAAW;ACCb;ADCA;EACE,mBAAa;ACCf;ADCA;EACE,iBAAY;ACCd;ADCA;EACE,kBAAY;ACCd;ADCA;EACE,gBAAY;ACCd;ADCA;EACE,eAAW;ACCb;ADCA;;EACE,oBAAa;EACb,gBAAa;EACb,gBAAa;EACb,gBAAY;EACZ,mBAAe;ACEjB;ADAA;;;;EACE,oBAAa;EACb,kBAAW;EACX,oBAAa;ACKf;ADHA;EACE,mBAAc;EACd,kBAAa;ACKf;ADHA;EACE,sBAAO;ACKT;ADHA;EACE,uBAAO;ACKT;ADHA;EACE,UAAS;EACT,wCAAoB;EACpB,mCAAe;EACf,gCAAY;ACKd;ADHA;EACE,UAAS;ACKX;ADHA;EACE,cAAO;EACP,qBAAiB;ACKnB;AAzEA;EACE,kBAAU;EACV,aAAS;EACT,cAAS;EACT,2DAA6B;EAC7B,eAAW;EACX,kBAAY;EACZ,gBAAa;EACb,uBAAa;EACb,gBAAY;EACZ,iBAAY;EACZ,qBAAiB;EACjB,iBAAa;EACb,oBAAgB;EAChB,sBAAgB;EAChB,kBAAY;EACZ,oBAAc;EACd,iBAAW;EACX,mBAAa;EACb,UAAS;EACT,gBAAY;AA2Ed;AAzEE;EACE,YAAS;AA2Eb;AAzEE;EACE,gBAAY;EACZ,cAAS;AA2Eb;AAzEE;EACE,gBAAa;EACb,cAAS;AA2Eb;AAzEE;EACE,eAAY;EACZ,cAAS;AA2Eb;AAzEE;EACE,iBAAa;EACb,cAAS;AA2Eb;AAzEE;EACE,SAAQ;EACR,SAAM;EACN,iBAAa;EACb,uBAAc;EACd,sBAAkB;AA2EtB;AAxEE;EACE,QAAK;EACL,OAAM;EACN,gBAAY;EACZ,2BAAc;EACd,wBAAoB;AA0ExB;AAxEE;EACE,QAAK;EACL,QAAO;EACP,gBAAY;EACZ,2BAAc;EACd,uBAAmB;AA0EvB;AAxEE;EACE,MAAK;EACL,SAAM;EACN,iBAAa;EACb,uBAAc;EACd,yBAAqB;AA0EzB;AAvEA;EACE,gBAAW;EACX,gBAAS;EACT,WAAO;EACP,kBAAY;EACZ,sBAAkB;EAClB,kBAAe;AAyEjB;AAtEA;EACE,kBAAU;EACV,QAAO;EACP,SAAQ;EACR,yBAAc;EACd,mBAAc;AAwEhB;AArEA;EACE,YAAS;AAuEX","sourcesContent":["*\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n.full-width\n  width: 100%\n\n.full-height\n  height: 100%\n\n.flex-h\n  display: flex\n  flex-direction: row\n\n.flex-v\n  display: flex\n  flex-direction: column\n\n.flex-grow\n  flex-grow: 1\n\n.nowrap\n  white-space: nowrap\n\n.text-right\n  text-align: right;\n\n.text-center\n  text-align: center;\n\n.text-left\n  text-align: left;\n\nh1\n  font-size: 36px;\n\nh3, h1\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n\nbutton, input, select, textarea\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n\n.row\n  margin-right: -15px;\n  margin-left: -15px;\n\n.pull-left\n  float: left!important;\n\n.pull-right\n  float: right!important;\n\n.fade\n  opacity: 0;\n  -webkit-transition: opacity .15s linear;\n  -o-transition: opacity .15s linear;\n  transition: opacity .15s linear;\n\n.fade.in\n  opacity: 1;\n\na\n  color: #8784EE;\n  text-decoration: none;\n","@import '../common/global.styl'\n\n.tooltip\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  opacity: 0;\n  line-break: auto;\n\n  &.in\n    opacity: .9;\n\n  &.top\n    margin-top: -3px;\n    padding: 5px 0;\n\n  &.right\n    margin-left: 3px;\n    padding: 0 5px;\n\n  &.bottom\n    margin-top: 3px;\n    padding: 5px 0;\n\n  &.left\n    margin-left: -3px;\n    padding: 0 5px;\n\n  &.top .tooltip-arrow {\n    bottom: 0;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000;\n  }\n\n  &.right .tooltip-arrow {\n    top: 50%;\n    left: 0;\n    margin-top: -5px;\n    border-width: 5px 5px 5px 0;\n    border-right-color: #000;\n  }\n  &.left .tooltip-arrow {\n    top: 50%;\n    right: 0;\n    margin-top: -5px;\n    border-width: 5px 0 5px 5px;\n    border-left-color: #000;\n  }\n  &.bottom .tooltip-arrow {\n    top: 0;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000;\n  }\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px;\n}\n\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.tooltip.in\n  opacity: .9;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
